<template>
	<v-container>
		<v-sheet color="primary" class="pa-4 rounded-t-lg" dark>
			<v-row>
				<v-col cols="12" class="d-flex justify-center">
					<v-img :src="require('@/assets/logo.svg')" max-height="90" max-width="350" 
						contain transition="scale-transition"/>
				</v-col>
				<v-col cols="12" class="headline text-center">
					Somos el primer gran paso para modernizar tu negocio
				</v-col>
			</v-row>
		</v-sheet>
		<v-sheet color="white" class="pa-4 rounded-b-lg">
			<v-row>
				<v-col cols="12">
					<v-tabs v-model="indicePasoActual" show-arrows fixed-tabs>
						<v-tabs-slider color="primary">
						</v-tabs-slider>
						<v-tab v-for="(paso, indice) in pasos" :key="paso" :disabled="!pasoEsAccesible(indice)">
							<v-avatar color="primary" size="24" class="mr-2">
								<span class="white--text">
									{{ indice + 1 }}
								</span>
							</v-avatar>
							{{ paso.titulo }}
						</v-tab>
					</v-tabs>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-tabs-items v-model="indicePasoActual" touchless>
						<v-tab-item v-for="(paso, indice) in pasos" :key="paso">
							<component :is="paso.componente" :activo="indicePasoActual === indice" @notificacion="mostrarNotificacion"
												 @datos="establecerDatosPaso(paso, ...arguments)" :datos-plan="datosPlan" :datos-cliente="datosCliente"
												 :datos-resumen="datosResumen" :indice-paso-plan="indicePasoPlan" :indice-paso-cliente="indicePasoCliente"
												 @cambio-paso="cambiarPaso" :vendedor-encriptado="vendedorEncriptado" :datos-adicionales="datosAdicionales"
												 :vendedor-asistente="vendedorAsistente" :datos-prellenado="datosPrellenado"
												 :cargando-datos-prellenado="cargandoDatosPrellenado"/>
						</v-tab-item>
					</v-tabs-items>
				</v-col>
				<v-col cols="12" class="d-flex justify-center">
					<v-btn color="primary" :disabled="(indicePasoActual === 0)" @click="indicePasoActual = (indicePasoActual - 1)" class="ma-1" 
						large depressed>
						<v-icon left>
							chevron_left
						</v-icon>
						Anterior
					</v-btn>
					<v-btn color="primary" :disabled="(indicePasoActual >= pasos.length - 1) || !pasoEsAccesible(indicePasoActual + 1)" 
						@click="indicePasoActual = indicePasoActual + 1" class="ma-1" large depressed>
						Siguiente
						<v-icon right>
							chevron_right
						</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-sheet>
		<v-snackbar v-model="notificacion.visible" :timeout="notificacion.tiempo" :color="notificacion.color">
			{{ notificacion.mensaje }}
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="notificacion.visible = false">
					Cerrar
				</v-btn>
			</template>
		</v-snackbar>
	</v-container>
</template>

<script>
import { API } from 'aws-amplify';
import * as config from '@/config';
import urlJoin from 'url-join';

import ComponentePlan from '@/components/Contratacion/Plan';
import ComponenteAdicionales from '@/components/Contratacion/Adicionales';
import ComponenteCliente from '@/components/Contratacion/Cliente';
import ComponenteResumen from '@/components/Contratacion/Resumen';
import ComponentePago from '@/components/Contratacion/Pago';

let pasoPlan = {'componente': ComponentePlan, 'titulo': 'Plan', 'completado': false, 'datos': {}};
let pasoAdicionales = {'componente': ComponenteAdicionales, 'titulo': 'Adicionales', 'completado': false, 'datos': {}};
let pasoCliente = {'componente': ComponenteCliente, 'titulo': 'Cliente', 'completado': false, 'datos': {}};
let pasoResumen = {'componente': ComponenteResumen, 'titulo': 'Resumen', 'completado': false, 'datos': {}};
let pasoPago = {'componente': ComponentePago, 'titulo': 'Pago', 'completado': false, 'datos': {}};

export default {
	components: {
		ComponentePlan,
		ComponenteAdicionales,
		ComponenteCliente,
		ComponenteResumen,
		ComponentePago,
	},
	data: () => ({
		notificacion: {
			visible: false,
			mensaje: undefined,
			color: undefined,
			tiempo: 5000,
		},
		pasoPlan, // Dejar objetos de pasos aquí, para reactividad (?)
		pasoAdicionales,
		pasoCliente,
		pasoResumen,
		pasoPago,
		indicePasoActual: 0,
		// Datos para prellenar algunos pasos
		datosPrellenado: undefined,
		cargandoDatosPrellenado: false,
	}),
	computed: {
		datosPlan: function() {
			let vm = this;
			let datos = vm.pasoPlan.datos;
			return datos;
		},
		datosAdicionales: function() {
			let vm = this;
			let datos = vm.pasoAdicionales.datos;
			return datos;
		},
		datosCliente: function() {
			let vm = this;
			let datos = vm.pasoCliente.datos;
			return datos;
		},
		datosResumen: function() {
			let vm = this;
			let datos = vm.pasoResumen.datos;
			return datos;
		},
		pasos: function() {
			let vm = this;
			// Enumerar pasos, en el orden en que aparecerán
			return [
				vm.pasoPlan,
				vm.pasoAdicionales,
				vm.pasoCliente,
				vm.pasoResumen,
				vm.pasoPago,
			];
		},
		indicePasoPlan: function() {
			let vm = this;
			let indice = vm.pasos.indexOf(vm.pasoPlan);
			return indice === -1? undefined : indice;
		},
		indicePasoCliente: function() {
			let vm = this;
			let indice = vm.pasos.indexOf(vm.pasoCliente);
			return indice === -1? undefined : indice;
		},
		vendedorEncriptado: function() {
			let vm = this;
			let vendedorParam = vm.$route.params.vendedor;
			let hayVendedorParam = (vendedorParam !== undefined);
			let vendedorEncriptado = hayVendedorParam ? vendedorParam : undefined;
			return vendedorEncriptado;
		},
		vendedorAsistente: function() {
			let vm = this;
			let vendedorAsistenteParam = vm.$route.params['vendedorasistente'];
			let hayVendedorAsistenteParam = (vendedorAsistenteParam !== undefined);
			let vendedorAsistente = hayVendedorAsistenteParam ? vendedorAsistenteParam : undefined;
			return vendedorAsistente;
		},
		tokenPrellenado: function() {
			let vm = this;
			let tokenPrellenadoParam = vm.$route.params['tokenprellenado'];
			let hayTokenPrellenadoParam = (tokenPrellenadoParam !== undefined);
			let tokenPrellenado = hayTokenPrellenadoParam ? tokenPrellenadoParam : undefined;
			return tokenPrellenado;
		},
	},
	methods: {
		mostrarNotificacion: function(datosNotificacion) {
			let vm = this;
			let mensaje = datosNotificacion.mensaje;
			let tipo = datosNotificacion.tipo;
			let colores = {
				'error': 'error',
				'warning': 'warning',
				'success': 'success',
				'info': 'primary',
			};
			let notificacion = vm.notificacion;
			notificacion.mensaje = mensaje;
			notificacion.color = colores[tipo];
			notificacion.visible = true;
		},
		establecerDatosPaso: function(paso, valido, datos) {
			paso.completado = valido;
			paso.datos = valido ? datos : {};
		},
		pasoEsAccesible: function(indicePaso) {
			let vm = this;
			let andReducer = function(x, y) { return (x && y.completado); };
			let esAccesible = vm.pasos.slice(0, indicePaso).reduce(andReducer, true);
			return esAccesible;
		},
		cambiarPaso: function(indicePaso) {
			let vm = this;
			let esAccesible = vm.pasoEsAccesible(indicePaso);
			if(!esAccesible) {
				vm.mostrarNotificacion(`Se intentó acceder a la pestaña ${indicePaso}, pero es inaccesible`);
				return;
			}
			vm.indicePasoActual = indicePaso;
		},
		obtenerDatosPrellenado: async function(token) {
			let vm = this;
			let apiName = config.autocontratarApiName;
			let path = urlJoin('/contratacion-prellenada/datos-prellenado', token); // Concatenar URL de forma segura
			let init = {
				headers: {},
				body: {},
			};
			vm.cargandoDatosPrellenado = true;
			try {
				let response = await API.get(apiName, path, init);
				vm.datosPrellenado = response;
			}
			catch(e) {
				const response = e.response;
				const mensaje = response ? response.data : e.toString(); // Mensaje de error
				const tipo = 'error';
				vm.mostrarNotificacion({mensaje, tipo});
			}
			finally {
				vm.cargandoDatosPrellenado = false;
			}
		},
	},
	mounted: function() {
		let vm = this;
		let tokenPrellenado = vm.tokenPrellenado;
		if(tokenPrellenado) {
			vm.obtenerDatosPrellenado(tokenPrellenado); // Async
		}
	}
};
</script>
